import { OfferProps } from "../../../../../components/offer/types";
import {Translate} from "../../../../../locales/locales-utils";
import {getUserEntryPointUrl} from "../../../../../helpers/getUserEntryPointUrl";

type Props = {
  isAuthorizedUser: boolean;
}

export const offerProps = ({ isAuthorizedUser }: Props): OfferProps => {
  return {
    title: Translate("Index.Offer.Title"),
    button: {
      text: Translate("Index.Offer.Button"),
      href: getUserEntryPointUrl(isAuthorizedUser),
      target: "_blank",
      variant: "primary",
      size: "lg"
    }
  }
};
